import { Color } from '../../../enums/color'
import { IconName } from '../../Icon'
import { SectionMessageVariant } from '../types'

interface SectionMessageStyles {
  color: Color
  bgColor: Color
  icon: IconName
}

export const variantStyles: Record<SectionMessageVariant, SectionMessageStyles> = {
  error: {
    color: Color.Grey950,
    bgColor: Color.Red100,
    icon: 'circleAlert',
  },
  warning: {
    color: Color.Grey950,
    bgColor: Color.Yellow100,
    icon: 'circleAlert',
  },
  info: {
    color: Color.Grey950,
    bgColor: Color.Lavender100,
    icon: 'info',
  },
  success: {
    color: Color.Grey950,
    bgColor: Color.Green100,
    icon: 'circleCheck',
  },
  neutral: {
    color: Color.Grey950,
    bgColor: Color.Grey100,
    icon: 'info',
  },
}
